import ServiceDetailPage from "./utilities/servicedetailpage";
import { servicePageContent } from "./utilities/servicepagecontent";

export default function AdCreatives() {
  return <ServiceDetailPage service={servicePageContent.adCreatives} />;
}
